// Combined filtering functionality for Maschenprobe and Nadelstärke with duplicate elimination
document.addEventListener('DOMContentLoaded', function() {
  // Initialize selected filters arrays
  let selectedMaschenprobeFilters = [];
  let selectedNadelNrFilters = [];
  
  // Function to normalize values for standardization and comparison
  function normalizeValue(value) {
    if (!value) return '';
    return value
      .replace(/&nbsp;/g, ' ')     // Replace HTML non-breaking spaces
      .replace(/\s+/g, '')         // Remove ALL whitespace
      .replace(/,/g, '.')          // Replace commas with dots
      .toLowerCase();              // Convert to lowercase
  }
  
  // Function to create a more readable display value
  function createDisplayValue(value) {
    if (!value) return '';
    // First normalize to remove extra spaces
    return value
      .replace(/&nbsp;/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  
  // Process Maschenprobe values on page load to eliminate duplicates
  function processMaschenprobeFilters() {
    // Get all Maschenprobe filter values
    const maschenprobeCheckboxes = document.querySelectorAll('input[name="maschenprobe-filter"]');
    
    // Create a map to store unique values
    const uniqueValues = new Map();
    
    // Process all checkboxes to find unique normalized values
    maschenprobeCheckboxes.forEach(checkbox => {
      const originalValue = checkbox.value;
      const normalizedValue = normalizeValue(originalValue);
      
      // If we haven't seen this normalized value before, or this representation is cleaner
      if (!uniqueValues.has(normalizedValue) || 
          originalValue.length < uniqueValues.get(normalizedValue).originalValue.length) {
        uniqueValues.set(normalizedValue, {
          originalValue: originalValue,
          displayValue: createDisplayValue(originalValue),
          checkboxes: [checkbox]
        });
      } else {
        // Add this checkbox to the list for this normalized value
        uniqueValues.get(normalizedValue).checkboxes.push(checkbox);
      }
    });
    
    // Now rebuild the filter list with only unique values
    const filterList = document.querySelector('#filter-filter\\.p\\.m\\.custom\\.maschenprobe ul');
    if (filterList) {
      // Clear existing list
      filterList.innerHTML = '';
      
      // Add unique values to the list
      let counter = 0;
      uniqueValues.forEach((valueData, normalizedValue) => {
        counter++;
        const isHidden = counter > 6;
        
        const listItem = document.createElement('li');
        if (isHidden) {
          listItem.className = 'js-hidden';
        }
        
        const safeId = `maschenprobe-${normalizedValue}`;
        
        listItem.innerHTML = `
          <input type="checkbox" class="checkbox" id="${safeId}" name="maschenprobe-filter" 
                 value="${valueData.displayValue}" data-normalized="${normalizedValue}" 
                 onchange="applyMaschenprobeFilters(this)">
          <label for="${safeId}" class="flex items-start w-full m-0">
            <span class="flex-auto">${valueData.displayValue}</span>
          </label>
        `;
        
        filterList.appendChild(listItem);
      });
    }
  }
  
  // Process Nadelstärke values on page load to eliminate duplicates
  function processNadelNrFilters() {
    // Get all Nadelstärke filter values
    const nadelNrCheckboxes = document.querySelectorAll('input[name="nadel-nr-filter"]');
    
    // Create a map to store unique values
    const uniqueValues = new Map();
    
    // Process all checkboxes to find unique normalized values
    nadelNrCheckboxes.forEach(checkbox => {
      const originalValue = checkbox.value;
      const normalizedValue = normalizeValue(originalValue);
      
      // If we haven't seen this normalized value before, or this representation is cleaner
      if (!uniqueValues.has(normalizedValue) || 
          originalValue.length < uniqueValues.get(normalizedValue).originalValue.length) {
        uniqueValues.set(normalizedValue, {
          originalValue: originalValue,
          displayValue: createDisplayValue(originalValue),
          checkboxes: [checkbox]
        });
      } else {
        // Add this checkbox to the list for this normalized value
        uniqueValues.get(normalizedValue).checkboxes.push(checkbox);
      }
    });
    
    // Now rebuild the filter list with only unique values
    const filterList = document.querySelector('#filter-filter\\.p\\.m\\.custom\\.nadel_nr_ ul');
    if (filterList) {
      // Clear existing list
      filterList.innerHTML = '';
      
      // Add unique values to the list
      let counter = 0;
      uniqueValues.forEach((valueData, normalizedValue) => {
        counter++;
        const isHidden = counter > 6;
        
        const listItem = document.createElement('li');
        if (isHidden) {
          listItem.className = 'js-hidden';
        }
        
        const safeId = `nadel-nr-${normalizedValue}`;
        
        listItem.innerHTML = `
          <input type="checkbox" class="checkbox" id="${safeId}" name="nadel-nr-filter" 
                 value="${valueData.displayValue}" data-normalized="${normalizedValue}" 
                 onchange="applyNadelNrFilters(this)">
          <label for="${safeId}" class="flex items-start w-full m-0">
            <span class="flex-auto">${valueData.displayValue}</span>
          </label>
        `;
        
        filterList.appendChild(listItem);
      });
    }
  }
  
  // Function to apply Maschenprobe filters
  window.applyMaschenprobeFilters = function(checkbox) {
    const value = checkbox.getAttribute('data-normalized') || normalizeValue(checkbox.value);
    
    // Update selected filters array
    if (checkbox.checked) {
      if (!selectedMaschenprobeFilters.includes(value)) {
        selectedMaschenprobeFilters.push(value);
      }
    } else {
      const index = selectedMaschenprobeFilters.indexOf(value);
      if (index > -1) {
        selectedMaschenprobeFilters.splice(index, 1);
      }
    }
    
    // Apply combined filters
    applyCombinedFilters();
    console.log("Selected Maschenprobe filters:", selectedMaschenprobeFilters);
  };
  
  // Function to apply Nadelstärke filters
  window.applyNadelNrFilters = function(checkbox) {
    const value = checkbox.getAttribute('data-normalized') || normalizeValue(checkbox.value);
    
    // Update selected filters array
    if (checkbox.checked) {
      if (!selectedNadelNrFilters.includes(value)) {
        selectedNadelNrFilters.push(value);
      }
    } else {
      const index = selectedNadelNrFilters.indexOf(value);
      if (index > -1) {
        selectedNadelNrFilters.splice(index, 1);
      }
    }
    
    // Apply combined filters
    applyCombinedFilters();
    console.log("Selected Nadelstärke filters:", selectedNadelNrFilters);
  };
  
  // Function to apply both filters together
  function applyCombinedFilters() {
    // Get all collection items
    const collectionItems = document.querySelectorAll('.js-collection-item');
    
    // If no filters selected, show all items
    if (selectedMaschenprobeFilters.length === 0 && selectedNadelNrFilters.length === 0) {
      collectionItems.forEach(item => {
        item.style.display = '';
      });
      updateActiveFilters(false);
      return;
    }
    
    // Filter items based on selected values
    collectionItems.forEach(item => {
      let shouldShowItem = true;
      
      // Check Maschenprobe filters if any are selected
      if (selectedMaschenprobeFilters.length > 0) {
        const itemMaschenprobeValue = item.getAttribute('data-maschenprobe');
        
        if (!itemMaschenprobeValue) {
          shouldShowItem = false;
        } else {
          const normalizedItemValue = normalizeValue(itemMaschenprobeValue);
          
          // Check if any of the selected filters match
          const hasMatch = selectedMaschenprobeFilters.some(filter => 
            normalizedItemValue.includes(filter)
          );
          
          if (!hasMatch) {
            shouldShowItem = false;
          }
        }
      }
      
      // Check Nadelstärke filters if any are selected
      if (shouldShowItem && selectedNadelNrFilters.length > 0) {
        const itemNadelNrValue = item.getAttribute('data-nadel_nr_');
        
        if (!itemNadelNrValue) {
          shouldShowItem = false;
        } else {
          const normalizedItemValue = normalizeValue(itemNadelNrValue);
          
          // Check if any of the selected filters match
          const hasMatch = selectedNadelNrFilters.some(filter => {
            return normalizedItemValue.includes(filter);
          });
          
          if (!hasMatch) {
            shouldShowItem = false;
          }
        }
      }
      
      // Show or hide based on combined results
      item.style.display = shouldShowItem ? '' : 'none';
    });
    
    // Update active filters display
    updateActiveFilters(true);
  }
  
  // Function to update active filters section
  function updateActiveFilters(hasActiveFilters) {
    const activeFiltersSection = document.querySelector('.facets__active-filters');
    if (activeFiltersSection) {
      activeFiltersSection.hidden = !hasActiveFilters;
      
      // Clear existing active filter tags
      const activeFiltersContainer = activeFiltersSection.querySelector('.active-filters');
      if (activeFiltersContainer) {
        activeFiltersContainer.innerHTML = '';
        
        // Add active filter tags for Maschenprobe
        if (hasActiveFilters) {
          // Get display values for selected Maschenprobe filters
          const selectedMaschenprobeDisplays = selectedMaschenprobeFilters.map(normalized => {
            const checkbox = document.querySelector(`input[data-normalized="${normalized}"]`);
            return checkbox ? checkbox.value : normalized;
          });
          
          selectedMaschenprobeDisplays.forEach(displayValue => {
            const filterTag = document.createElement('a');
            filterTag.href = 'javascript:void(0)';
            filterTag.className = 'active-filter flex items-center text-current';
            filterTag.innerHTML = `
              <svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5">
                <path d="M12 4L4 12M4 4l8 8" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              Maschenprobe: ${displayValue}
            `;
            filterTag.addEventListener('click', function() {
              // Find and uncheck the corresponding checkbox
              const normalized = normalizeValue(displayValue);
              const checkbox = document.querySelector(`input[data-normalized="${normalized}"]`);
              if (checkbox) {
                checkbox.checked = false;
                applyMaschenprobeFilters(checkbox);
              }
            });
            activeFiltersContainer.appendChild(filterTag);
          });
          
          // Get display values for selected Nadelstärke filters
          const selectedNadelNrDisplays = selectedNadelNrFilters.map(normalized => {
            const checkbox = document.querySelector(`input[data-normalized="${normalized}"]`);
            return checkbox ? checkbox.value : normalized;
          });
          
          // Add active filter tags for Nadelstärke
          selectedNadelNrDisplays.forEach(displayValue => {
            const filterTag = document.createElement('a');
            filterTag.href = 'javascript:void(0)';
            filterTag.className = 'active-filter flex items-center text-current';
            filterTag.innerHTML = `
              <svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5">
                <path d="M12 4L4 12M4 4l8 8" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              Nadelstärke: ${displayValue}
            `;
            filterTag.addEventListener('click', function() {
              // Find and uncheck the corresponding checkbox
              const normalized = normalizeValue(displayValue);
              const checkbox = document.querySelector(`input[data-normalized="${normalized}"]`);
              if (checkbox) {
                checkbox.checked = false;
                applyNadelNrFilters(checkbox);
              }
            });
            activeFiltersContainer.appendChild(filterTag);
          });
        }
      }
      
      // Toggle visibility of clear all button
      const clearAllButton = activeFiltersSection.querySelector('.js-clear-all');
      if (clearAllButton) {
        clearAllButton.addEventListener('click', function(e) {
          e.preventDefault();
          clearAllFilters();
        });
      }
      
      // Toggle visibility of clear filter buttons
      const clearFilterButtons = document.querySelectorAll('.js-clear-filter');
      clearFilterButtons.forEach(button => {
        button.hidden = !hasActiveFilters;
        button.addEventListener('click', function() {
          clearAllFilters();
        });
      });
    }
  }
  
  // Function to clear all filters
  function clearAllFilters() {
    // Uncheck all Maschenprobe checkboxes
    const maschenprobeCheckboxes = document.querySelectorAll('input[name="maschenprobe-filter"]');
    maschenprobeCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Uncheck all Nadelstärke checkboxes
    const nadelNrCheckboxes = document.querySelectorAll('input[name="nadel-nr-filter"]');
    nadelNrCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Reset selected filters arrays
    selectedMaschenprobeFilters = [];
    selectedNadelNrFilters = [];
    
    // Show all collection items
    const collectionItems = document.querySelectorAll('.js-collection-item');
    collectionItems.forEach(item => {
      item.style.display = '';
    });
    
    // Update active filters display
    updateActiveFilters(false);
  }
  
  // Handle "Show more" functionality for all filter groups
  const showMoreButtons = document.querySelectorAll('.js-show-more');
  showMoreButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Find the closest filter group
      const filterGroup = this.closest('.filter');
      if (filterGroup) {
        // Show hidden filter items in this group
        const hiddenItems = filterGroup.querySelectorAll('.js-hidden');
        hiddenItems.forEach(item => {
          item.classList.remove('js-hidden');
        });
        
        // Hide this "Show more" button
        this.style.display = 'none';
      }
    });
  });
  
  // Process filters on page load to remove duplicates
  processMaschenprobeFilters();
  processNadelNrFilters();
});